module.exports = __webpack_public_path__ + "assets/img/DS-room1 (2).a0ee37a3.jpg";